import { EventHandler } from 'app/classes';
import { clone, Url, Singleton } from 'app/utils';

export class WindowService {

    public html = document.getElementsByTagName('html')[0];
    public body = document.getElementsByTagName('body')[0];
    public frameContainer = document.getElementById('frame-container');

    public baseUrl: string;
    private currentLocation: Location;
    private locationHandler: EventHandler;

    constructor() {

        // MessageBus uses this name when sending post messages
        // to application iframes, which check for this value.

        window.name = 'sps-commerce-platform';

        this.baseUrl = Url.parse(this.currentUrl()).origin;
        this.locationHandler = new EventHandler();
        this.currentLocation = clone(window.location);

        // This is the only reliable way to watch the location
        // for changes. No watch, observe, or proxy will work
        // on window.location.

        setInterval(this.checkLocationForChanges, 200);

        // Setup an event dispatcher so that we can close our
        // fly-out windows from the bluebar when the user clicks.
        window.addEventListener('blur', (event) => {
            if (document.activeElement.tagName === 'IFRAME' || document.activeElement.tagName === 'BODY') {
                dispatchEvent(new CustomEvent('clickOut'));
            }
        });
    }

    private checkLocationForChanges = () => {
        if (window.location.href !== this.currentLocation.href) {
            this.locationHandler.trigger(window.location, this.currentLocation);
            this.currentLocation = clone(window.location);
        }
    };

    public onLocationChange = (callback: () => void) => {
        return this.locationHandler.register(callback);
    };

    public currentUrl() {
        return window.location.toString();
    }

    /**
     * Update our parent window title with app/page titles.
     *
     * Examples:
     *    Fulfillment : SPS Commerce
     *    Overview : Platform Admin : SPS Commerce
     *
     * @param {String} title
     * @param {String} [app]
     */
    public setTitle(title: string, app?: string) {
        const newTitle = [title, app, 'SPS Commerce'].filter(Boolean).join(' : ');
        window.document.title = String(newTitle);
    }

    /**
     * Update our parent window URL path with new app/path/?search value.
     *
     * @param {String} path
     * @param {String} [replace]
     */
    public setLocation(path: string, replace = false) {
        path = Url.absolute(path, this.baseUrl);
        if (replace) {
            window.history.replaceState({}, null, path);
        } else {
            window.history.pushState({}, null, path);
        }
    }

}

export let $Window = Singleton('$Window', WindowService);
